import React, { useEffect, useRef, useState, useCallback } from 'react'
import { fetchCategoryDataFilter, fetchOriginDataFilter, filteredCategories } from '../../../Utils/helper'
import MultiSelectDropdown from '../../../Utils/multiSelectDropdown';
import { getApi } from '../../../Services/apiService';

function AddEditArrival({ setMethodType, resetForm, touched, errors, formData, handleInputChange, handleBlur, suppliers, shippingMethods, handleDateChange, searchTerm, setIsDropdownOpen, isDropdownOpen, filteredProducts, selectedProducts, setSearchTerm, handleProductClick, setShowAddProductModal, setProductSearchQuery, setAvailableProducts, setSelectedProducts, fetchAvailableProducts, toggleAllProductsCheckbox, products, toggleProductCheckbox, handleProductChange, removeProduct, handleAddArrival, isLoading, type, arrivalToEdit, selectedShowProducts, resetFormArrival, setFilterData, filterDatas, productlist, setProductList,setSelectedShowProducts, isModal }) {
  const [supplierDropdown, setSupplierDropdown] = useState(false)
    const [categoryData, setCategoryData] = useState([])
  const [selectedCategoryIds, setSelectedCategoryIds] = useState([])
  const [originData, setOriginData] = useState([])
  const [selectedOriginIds, setSelectedOriginIds] = useState([])
  const [shippingDropdown, setShippingDropdown] = useState(false)
  const [statusDropdown, setStatusDropdown] = useState(false)
  const [searchShowProduct, setSearchShowProduct] = useState('')
  const [filterShowProduct, setFilterShowProduct] = useState([])
  const [containerFieldInfo, setContainerFieldInfo] = useState({
    label: "Container No/Air/Local/Truck",
    placeholder: "Enter Container No. / Flight No. / Local"
  })
  const [scrolled, setScrolled] = useState(false);
  const [page,setPage] = useState(1)
  // const [productList,setProductList] = useState([])
  const dropdownRef = useRef(null);
  const handleScroll = (e) => {
    setScrolled(e.target.scrollTop > 288);
 };

  const toggleProductCheck = (id, checked) => {
    setSelectedShowProducts(prev => {
      const productExists = prev.some(p => p.id === id);
      
      if (productExists) {
        return checked 
          ? prev.map(p => p.id === id ? { ...p, checked } : p)
          : prev.filter(p => p.id !== id);
      }
      
      return checked
        ? [...prev, { ...productlist.find(p => p.id === id), checked: true }]
        : prev;
    });
  };
  

  useEffect(()=>{
    // if(type!=='edit'){
    getProdcutData()
    // }
  },[selectedCategoryIds,selectedOriginIds,searchShowProduct])

  const getProdcutData = async () => {
    const queryParams = new URLSearchParams();
    if (Array.isArray(selectedCategoryIds)) {
      selectedCategoryIds.forEach((id) => queryParams.append('category_ids[]', id));
    } else if (selectedCategoryIds) {
      queryParams.append('category_ids[]', selectedCategoryIds);
    }
    if (Array.isArray(selectedOriginIds)) {
      selectedOriginIds.forEach((id) => queryParams.append('origin_ids[]', id));
    } else if (selectedOriginIds) {
      queryParams.append('origin_ids[]', selectedOriginIds);
    }
    queryParams.append('search', searchShowProduct);
    queryParams.append('page', 1);
    queryParams.append('per_page', 50);
      const response = await getApi(`/product?${queryParams.toString()}`) 
      if (response?.success) {
        // if(selectedCategoryIds?.length>0 || selectedOriginIds?.length>0){
        setProductList(response.data.products?.data || []);
        // }
      }
    }

  // Get container field label and placeholder based on shipping method
  const getContainerFieldInfo = useCallback(() => {
    const selectedMethod = shippingMethods.find(m => m.id === formData.shipping_method);
    if (!selectedMethod) return { label: "Container No/Air/Local/Truck", placeholder: "Enter Container No. / Flight No. / Local" };

    const methodName = selectedMethod.name?.toLowerCase() || "";

    if (methodName.includes("air")) {
      return { label: "Container No/Air", placeholder: "Enter Flight No." };
    } else if (methodName.includes("local")) {
      return { label: "Container No/Local", placeholder: "Enter Local" };
    } else if (methodName.includes("truck")) {
      return { label: "Container No/Truck", placeholder: "Enter Truck No." };
    } else {
      return { label: "Container No", placeholder: "Enter Container No." };
    }
  }, [formData.shipping_method, shippingMethods]);

  // Update container field info when shipping method changes
  useEffect(() => {
    handleGetCategory('', setCategoryData)
    handleGetOrigin('', setOriginData)

    setContainerFieldInfo(getContainerFieldInfo());
  }, [getContainerFieldInfo]);

  const toggleProductCheckboxs = (id, checked) => {
    setProductList(prev => prev.map(product =>
      product.id === id ? { ...product, checked } : product
    ));
  };

   const handleGetCategory = async () => {
     const resp = await getApi(`/product-category?per_page=100`)
     if (resp?.success) {
       setCategoryData(resp?.data?.productCategories?.data)
     }
   }
     const handleGetOrigin = async () => {
       const resp = await getApi(`/product-origin?per_page=100`)
       if (resp?.success) {
         setOriginData(resp?.data?.productOrigins?.data)
       }
     }
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setSupplierDropdown(false);
        setShippingDropdown(false)
        setStatusDropdown(false)
      }
    };

    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, []);
  useEffect(() => {
    if (searchShowProduct.trim() === '') {
      setFilterShowProduct([]);
      return;
    }
    const filtered = selectedShowProducts.filter(product => {
      if (!product?.name_en) return false;
      // const searchWords = searchShowProduct.toLowerCase().trim();
      const searchWords = searchShowProduct.toLowerCase().split(/\s+/).filter(Boolean);
      const productWords = product.name_en.toLowerCase().split(/\s+/);
      return searchWords.every(searchWord =>
        productWords.some(productWord =>
          productWord.includes(searchWord)
        )
      );
    });
    setFilterShowProduct(filtered);
  }, [searchShowProduct]);

  useEffect(() => {
    if (searchTerm !== '') {
      filterData()
    }
  }, [searchTerm])

  const filterData = () => {
    if (supplierDropdown) {
      const data = filteredCategories(searchTerm, suppliers);
      setFilterData(data?.length > 0 ? data : []);
    } else if (shippingDropdown) {
      const data = filteredCategories(searchTerm, shippingMethods);
      setFilterData(data?.length > 0 ? data : []);
    }
  }

  return (
    <div className="row">
      <div className="col-sm-12">
        <div className={`setting-right position-relative arrival-page ${isModal ? 'modal-add-edit-arrival' : ''}`} onScroll={handleScroll}>
          <h3>{type === 'add' ? 'Add' : type === 'clone' ? 'Clone' : 'Edit'} Arrival</h3>
          <img
            src={window.getPublicUrl('/assets/images/close.svg')}
            className="close"
            alt="Close"
            onClick={() => {
              setMethodType('');
              resetForm();
              setSelectedProducts([])
              setSelectedShowProducts([])
              setProductList([])
            }}
          />
          <div className='on-scroll-setting'>
          <div className="setting-inner">
            <div className="row">
              <div className="col-sm-4">
                <div className="form-group">
                  <label>
                    Supplier<strong>*</strong>
                  </label>
                  <div className='selctions-option position-relative' >
                    {/* <input placeholder="category" class="w-100 category affter-change-cs category-select" value=" Select Status" /> */}
                    <input
                      placeholder="Supplier"
                      className={`w-100 category affter-change-cs category-select ${touched.supplier && errors.supplier ? 'is-invalid' : ''} ${supplierDropdown ? 'before-change-cs' : ''}`}
                      value={!supplierDropdown ? suppliers.find(s => s.id === formData.supplier)?.name_en || '' : searchTerm}
                      onClick={() => { setSupplierDropdown(!supplierDropdown); setSearchTerm('') }}
                      onChange={(e) => setSearchTerm(e?.target?.value)}
                    // readOnly
                    />
                    {supplierDropdown &&
                      <div className='select-option w-100' ref={dropdownRef}>
                        {(searchTerm === '' ? suppliers?.length > 0 : filterDatas?.length > 0) ? (searchTerm === '' ? suppliers : filterDatas).map(supplier => (
                          <span key={supplier.id}>
                            <label className="checbox-cs">
                              <input
                                type="checkbox"
                                checked={formData.supplier === supplier.id}
                                onChange={() => {
                                  const newValue = formData.supplier === supplier.id ? '' : supplier.id;
                                  handleInputChange({
                                    target: {
                                      name: 'supplier',
                                      value: supplier.id  //newValue
                                    }
                                  });
                                  handleBlur({
                                    target: {
                                      name: 'supplier',
                                      value: supplier.id
                                    }
                                  });
                                  setSupplierDropdown(false)
                                }}
                              />
                              <span className="checkmark"></span>
                            </label>
                            {supplier.name_en} ({supplier.code})
                          </span>
                        ))
                          :
                          <span className="no-data-available">No Suppliers Available</span>
                        }
                      </div>
                    }

                  </div>
                  {touched.supplier && errors.supplier && (
                    <div className="invalid-feedback d-block">
                      {errors.supplier}
                    </div>
                  )}
                </div>
              </div>

              <div className="col-sm-4">
                <div className="form-group">
                  <label>
                    Shipping Method<strong>*</strong>
                  </label>
                  <div className='selctions-option position-relative'>
                    <input
                      placeholder="Shipping Method"
                      className={`w-100 category affter-change-cs category-select ${touched.shipping_method && errors.shipping_method ? 'is-invalid' : ''} ${shippingDropdown ? 'before-change-cs' : ''}`}
                      value={!shippingDropdown ? shippingMethods.find(m => m.id === formData.shipping_method)?.name || '' : searchTerm}
                      onClick={() => { setShippingDropdown(!shippingDropdown); setSearchTerm('') }}
                      onChange={(e) => setSearchTerm(e?.target?.value)}
                    />
                    {shippingDropdown &&
                      <div className='select-option w-100' ref={dropdownRef}>
                        {(searchTerm === '' ? shippingMethods?.length > 0 : filterDatas?.length > 0) ? (searchTerm === '' ? shippingMethods : filterDatas).map(method => (
                          <span key={method.id}>
                            <label className="checbox-cs">
                              <input
                                type="checkbox"
                                checked={formData.shipping_method === method.id}
                                onChange={() => {
                                  handleInputChange({
                                    target: {
                                      name: 'shipping_method',
                                      value: method.id
                                    }
                                  });
                                  handleBlur({
                                    target: {
                                      name: 'shipping_method',
                                      value: method.id
                                    }
                                  });
                                  setShippingDropdown(false)
                                }}
                              />
                              <span className="checkmark"></span>
                            </label>
                            {method.name}
                          </span>
                        ))
                          :
                          <span className="no-data-available">No Shipping Method Available</span>
                        }
                      </div>
                    }
                  </div>
                  {touched.shipping_method && errors.shipping_method && (
                    <div className="invalid-feedback d-block">
                      {errors.shipping_method}
                    </div>
                  )}
                </div>
              </div>
              <div className="col-sm-4">
                <div className="form-group">
                  <label>Order Remark<strong>*</strong></label>
                  <input
                    type="text"
                    className={`form-control ${touched.order_remark && errors.order_remark ? 'is-invalid' : ''}`}
                    placeholder="Enter Order Remark"
                    name="order_remark"
                    value={formData.order_remark}
                    onChange={handleInputChange}
                  // onBlur={handleBlur}
                  />
                  {touched.order_remark && errors.order_remark && (
                    <div className="invalid-feedback d-block">
                      {errors.order_remark}
                    </div>
                  )}
                </div>
              </div>

              <div className="col-sm-4">
                <div className="form-group">
                  <label>
                    {containerFieldInfo.label}
                  </label>
                  <input
                    type="text"
                    className={`form-control ${touched.container_no && errors.container_no ? 'is-invalid' : ''}`}
                    placeholder={containerFieldInfo.placeholder}
                    name="container_no"
                    value={formData.container_no}
                    onChange={handleInputChange}
                    onBlur={handleBlur}
                  />
                  {touched.container_no && errors.container_no && (
                    <div className="invalid-feedback d-block">
                      {errors.container_no}
                    </div>
                  )}
                </div>
              </div>
              <div className="col-sm-4">
                <div className="form-group">
                  <label>ATD</label>
                  <input
                    type="date"
                    className={`form-control date ${touched.atd && errors.atd ? 'is-invalid' : ''} ${formData.atd !== '' ? 'datefilled' : ''}`}
                    name="atd"
                    value={formData.atd}
                    onChange={handleDateChange}
                    onBlur={handleBlur}
                    min={new Date().toISOString().split('T')[0]}
                  />
                  {touched.atd && errors.atd && (
                    <div className="invalid-feedback d-block">
                      {errors.atd}
                    </div>
                  )}
                </div>
              </div>
              <div className="col-sm-4">
                <div className="form-group">
                  <label>ATA</label>
                  <input
                    type="date"
                    className={`form-control date ${touched.ata && errors.ata ? 'is-invalid' : ''} ${formData.ata !== '' ? 'datefilled' : ''}`}
                    name="ata"
                    value={formData.ata}
                    onChange={handleDateChange}
                    onBlur={handleBlur}
                    min={new Date().toISOString().split('T')[0]}
                  />
                  {touched.ata && errors.ata && (
                    <div className="invalid-feedback d-block">
                      {errors.ata}
                    </div>
                  )}
                </div>
              </div>
              <div className="col-sm-4">
                <div className="form-group">
                  <label>ETA<strong>*</strong></label>
                  <input
                    type="date"
                    className={`form-control date ${touched.eta && errors.eta ? 'is-invalid' : ''} ${formData.eta !== '' ? 'datefilled' : ''}`}
                    name="eta"
                    value={formData.eta}
                    onChange={handleDateChange}
                    onBlur={handleBlur}
                    min={new Date().toISOString().split('T')[0]}
                  />
                  {touched.eta && errors.eta && (
                    <div className="invalid-feedback d-block">
                      {errors.eta}
                    </div>
                  )}
                </div>
              </div>
              {/* <div className="col-sm-4">
                <div className="form-group">
                  <label>
                    Status<strong>*</strong>
                  </label>
                  <div className='selctions-option position-relative'>
                    <input
                      placeholder="Status"
                      className={`w-100 category affter-change-cs category-select ${touched.status && errors.status ? 'is-invalid' : ''} ${statusDropdown ? 'before-change-cs' : ''}`}
                      value={formData.status == 1 ? 'Completed' : 'Incompleted'}
                      onClick={() => setStatusDropdown(!statusDropdown)}
                      readOnly
                    />
                    {statusDropdown &&
                      <div className='select-option w-100' ref={dropdownRef}>
                        <span>
                          <label className="checbox-cs">
                            <input
                              type="checkbox"
                              checked={formData.status == 0}
                              onChange={() => {
                                handleInputChange({
                                  target: {
                                    name: 'status',
                                    value: 0
                                  }
                                });
                                handleBlur({
                                  target: {
                                    name: 'status',
                                    value: 0
                                  }
                                });
                                setStatusDropdown(false);
                              }}
                            />
                            <span className="checkmark"></span>
                          </label>
                          Incompleted
                        </span>
                        <span>
                          <label className="checbox-cs">
                            <input
                              type="checkbox"
                              checked={formData.status == 1}
                              onChange={() => {
                                handleInputChange({
                                  target: {
                                    name: 'status',
                                    value: 1
                                  }
                                });
                                handleBlur({
                                  target: {
                                    name: 'status',
                                    value: 1
                                  }
                                });
                                setStatusDropdown(false);
                              }}
                            />
                            <span className="checkmark"></span>
                          </label>
                          Completed
                        </span>
                      </div>
                    }
                  </div>
                </div>
              </div> */}
              <div className="col-sm-4">
                <div className="form-group arival-id">
                  <label>Arrival Id</label>
                  <input
                    type="text"
                    className={`form-control date ${touched.eta && errors.eta ? 'is-invalid' : ''}`}
                    name="eta"
                    value={formData.arrival_id}
                  // onChange={handleDateChange}
                  />
                </div>
              </div>
            </div>
          </div>

          <div className="setting-right setting-right-table table-border-show product-grouping mx-3 mb-4 add-arrival">
            <div className="table-header">
              <div className='d-flex gap-4'>
                <div className="search-card d-flex align-items-center">
                  <img src={window.getPublicUrl('/assets/images/search-icon.svg')} alt="" />
                  <input type="text" className="search-input" placeholder="Search Product"
                    value={searchShowProduct}
                    onChange={(e) => setSearchShowProduct(e.target.value)}
                  />
                </div>

              
            
                        <MultiSelectDropdown
                          categoryData={categoryData}
                          selectedCategories={selectedCategoryIds}
                          setSelectedCategories={setSelectedCategoryIds}
                          placeholder='Select Categories...'
                          noOptionsMessage='No categories available'
                          setCurrentPage={setPage}
                          fetchOptionsApi={fetchCategoryDataFilter}
                          
                        />
                
                        <MultiSelectDropdown
                          categoryData={originData}
                          selectedCategories={selectedOriginIds}
                          setSelectedCategories={setSelectedOriginIds}
                          placeholder="Select origin..."
                          noOptionsMessage='No origin available'
                          setCurrentPage={setPage}
                          fetchOptionsApi={fetchOriginDataFilter}
                        />
                     
              </div>
              <div className='total-quantity'>
                <label>Total Quantity</label>
                <div className="total-quantity-box">
                  {selectedShowProducts?.reduce((total, item) => total + (Number(item.quantity) || 0), 0)}
                </div>
              </div>
                     <div className=''> <div className="button-settings d-flex justify-content-end gap-3 p-0 border-0">
        
                <button className="reset" onClick={() => resetFormArrival(type)}>
                  Reset
                </button>
                <button
                  className="save"
                  onClick={handleAddArrival}
                  disabled={isLoading}
                >
                  {isLoading ? 'Saving...' : 'Save'}
                </button>
              </div>
           </div> 
            </div>
            <div className={` ${scrolled ? 'scrolled-table-ui':'add-arr-table'}`}>
              <table className="custom-table table-striped product-bottom-cs">
                <thead>
                  <tr>
                    <th className="checkbox">
                    <label className="checbox-cs">
                      <input
                        type="checkbox"
                        onChange={(e) => toggleAllProductsCheckbox(e.target.checked)}
                        checked={productlist?.length > 0 && productlist.every(p => p.checked)}
                      />
                      <span className="checkmark"></span>
                    </label>
                  </th>
                    <th className="product-code">Product Code</th>
                    <th className="product-name">Product Name (TC)</th>
                    <th className="specification">Specification</th>
                    <th className="quantity">Quantity</th>
                    <th className="barcode">Barcode</th>
                    {/* <th className="action">Action</th> */}
                  </tr>
                </thead>

                <tbody>
                  {selectedShowProducts && selectedShowProducts?.length>0 &&  selectedShowProducts.map((product) => (
                    <tr key={product.id}>
                      <td className="checkbox">
                      <label className="checbox-cs">
                        <input
                          type="checkbox"
                          checked={product.checked}
                          onChange={(e) => toggleProductCheck(product.id, e.target.checked)}
                        />
                        <span className="checkmark"></span>
                      </label>
                    </td>
                      <td className="product-code">{product.code}</td>
                      <td className="product-name">{product.name_tc}</td>
                      <td className="specification">{product.specification}</td>
                      <td className="quantity">
                        <input
                          type="text"
                          className='input-enter'
                          // placeholder="10"
                          value={product.quantity}
                          onChange={(e) => handleProductChange(product.id, 'quantity', e.target.value)}
                        />
                      </td>
                      <td className="barcode">
                        <input
                          type="text"
                          className='input-enter'
                          // placeholder="10"
                          value={(product.barcode !== 'null' && product?.barcode !== null) ? product?.barcode : ''}
                          onChange={(e) => handleProductChange(product.id, 'barcode', e.target.value)}
                        />
                      </td>
                    </tr>
                  ))}
                  {productlist && productlist?.length>0 &&
                  productlist
                  .filter(product => 
                    !selectedShowProducts?.some(selected => selected.id === product.id)
                  ).map((product) => (
                    <tr key={product.id}>
                      <td className="checkbox">
                      <label className="checbox-cs">
                        <input
                          type="checkbox"
                          checked={false}
                          onChange={(e) => toggleProductCheck(product.id, e.target.checked)}
                        />
                        <span className="checkmark"></span>
                      </label>
                    </td>
                      <td className="product-code">{product.code}</td>
                      <td className="product-name">{product.name_tc}</td>
                      <td className="specification">{product.specification}</td>
                      <td className="quantity">
                        <input
                          type="text"
                          className='input-enter'
                          // placeholder="10"
                          value={product.quantity}
                          onChange={(e) => handleProductChange(product.id, 'quantity', e.target.value)}
                        />
                      </td>
                      <td className="barcode">
                        <input
                          type="text"
                          className='input-enter'
                          // placeholder="10"
                          value={(product.barcode !== 'null' && product?.barcode !== null) ? product?.barcode : ''}
                          onChange={(e) => handleProductChange(product.id, 'barcode', e.target.value)}
                        />
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          </div>
          </div>
        </div>
      </div>
    </div>
  )
}

export default AddEditArrival